// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-reij49-MuiInputBase-root-MuiFilledInput-root::after {
  border-bottom: 1px solid transparent !important;
}

.css-reij49-MuiInputBase-root-MuiFilledInput-root::before {
  border-bottom: 1px solid #000 !important;
}

.css-reij49-MuiInputBase-root-MuiFilledInput-root.Mui-focused {
  border-radius: 0px !important;
}

.MuiAutocomplete-endAdornment {
  margin-right: 20px !important;
  margin-top: 5px !important;
}

.MuiAutocomplete-hasPopupIcon.css-1x6bjyf-MuiAutocomplete-root
  .MuiFilledInput-root,
.MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root
  .MuiFilledInput-root {
  height: 50px !important;
}

.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root
  .MuiFilledInput-root {
  padding-top: 5px !important;
  color: #000;
  opacity: 1;
  font-size: 13px;
}

.MuiAutocomplete-inputRoot.MuiFilledInput-root {
  padding-top: 6px !important;
}

.MuiAutocomplete-input {
  transform: translateY(-1px) !important;
}

li.sizeList:hover {
  background: #007bc0 !important;
  color: #ffffff !important;
}

li#checkboxes-tags-demo-option-0 {
  height: 40px;
}

li.sizeList {
  display: flex;
  align-items: center;
  font-size: 13px;
  padding-right: 12px;
}

.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked,
.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate:focus {
  font-size: 16px !important;
  width: 24px !important;
  height: 24px !important;
  margin-left: 5px;
}

.css-ptiqhd-MuiSvgIcon-root {
  font-size: 1.6rem !important;
}

#CheckBoxOutlineBlankIcon {
  background: #007bc0 !important;
}

.MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator {
  margin-right: -23px !important;
  width: 20px !important;
  height: 20px !important;
}

.css-reij49-MuiInputBase-root-MuiFilledInput-root {
  cursor: pointer;
}

.css-1x6bjyf-MuiAutocomplete-root
  .MuiFilledInput-root
  .MuiAutocomplete-endAdornment {
  right: 5px !important;
  top: 44%;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/inputCheckBox/inputCheckBox.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;EAC3B,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,qBAAqB;EACrB,QAAQ;AACV","sourcesContent":[".css-reij49-MuiInputBase-root-MuiFilledInput-root::after {\n  border-bottom: 1px solid transparent !important;\n}\n\n.css-reij49-MuiInputBase-root-MuiFilledInput-root::before {\n  border-bottom: 1px solid #000 !important;\n}\n\n.css-reij49-MuiInputBase-root-MuiFilledInput-root.Mui-focused {\n  border-radius: 0px !important;\n}\n\n.MuiAutocomplete-endAdornment {\n  margin-right: 20px !important;\n  margin-top: 5px !important;\n}\n\n.MuiAutocomplete-hasPopupIcon.css-1x6bjyf-MuiAutocomplete-root\n  .MuiFilledInput-root,\n.MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root\n  .MuiFilledInput-root {\n  height: 50px !important;\n}\n\n.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1x6bjyf-MuiAutocomplete-root\n  .MuiFilledInput-root {\n  padding-top: 5px !important;\n  color: #000;\n  opacity: 1;\n  font-size: 13px;\n}\n\n.MuiAutocomplete-inputRoot.MuiFilledInput-root {\n  padding-top: 6px !important;\n}\n\n.MuiAutocomplete-input {\n  transform: translateY(-1px) !important;\n}\n\nli.sizeList:hover {\n  background: #007bc0 !important;\n  color: #ffffff !important;\n}\n\nli#checkboxes-tags-demo-option-0 {\n  height: 40px;\n}\n\nli.sizeList {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  padding-right: 12px;\n}\n\n.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked,\n.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate:focus {\n  font-size: 16px !important;\n  width: 24px !important;\n  height: 24px !important;\n  margin-left: 5px;\n}\n\n.css-ptiqhd-MuiSvgIcon-root {\n  font-size: 1.6rem !important;\n}\n\n#CheckBoxOutlineBlankIcon {\n  background: #007bc0 !important;\n}\n\n.MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator {\n  margin-right: -23px !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.css-reij49-MuiInputBase-root-MuiFilledInput-root {\n  cursor: pointer;\n}\n\n.css-1x6bjyf-MuiAutocomplete-root\n  .MuiFilledInput-root\n  .MuiAutocomplete-endAdornment {\n  right: 5px !important;\n  top: 44%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
